import * as React from 'react';
import { useSelector } from 'react-redux';

import { EarlyAccessPaywallProvider as Provider } from '../../../packages/EarlyAccessPaywall';
import { ESource } from '../../../packages/EarlyAccessPaywall/shared/types/context';
import { selectUser } from '../../selectors';
import { getEarlyAccessPaywallMicrofrontend } from '../../services/getEarlyAccessPaywallMicrofrontend';
import { useApplicationContext } from '../../utils/applicationContext';

export const EarlyAccessPaywallProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => getEarlyAccessPaywallMicrofrontend(context), [context]);
  const user = useSelector(selectUser);
  const isAuthenticated = !!user?.isAuthenticated;

  const params = {
    isAuthenticated,
    source: ESource.Favorites,
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
